<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#FFF7E4" />
    <path
      d="M39.998 21.2117L30.7049 19.8886L26.5505 11.6382C26.4371 11.4124 26.2504 11.2295 26.0198 11.1183C25.4415 10.8387 24.7388 11.0717 24.4496 11.6382L20.2953 19.8886L11.0021 21.2117C10.7459 21.2476 10.5116 21.3659 10.3323 21.5452C10.1155 21.7635 9.99599 22.0572 10.0001 22.3618C10.0042 22.6663 10.1316 22.9568 10.3542 23.1694L17.078 29.5912L15.4895 38.6591C15.4522 38.8701 15.4761 39.087 15.5583 39.2854C15.6405 39.4837 15.7778 39.6555 15.9546 39.7813C16.1314 39.9071 16.3406 39.9819 16.5586 39.9971C16.7766 40.0123 16.9946 39.9674 17.1878 39.8675L25.5001 35.5863L33.8123 39.8675C34.0393 39.9858 34.3028 40.0252 34.5554 39.9822C35.1922 39.8746 35.6205 39.283 35.5107 38.6591L33.9221 29.5912L40.6459 23.1694C40.8289 22.9938 40.9497 22.7643 40.9863 22.5133C41.0851 21.8858 40.6386 21.305 39.998 21.2117Z"
      fill="url(#paint0_linear_1005_5898)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1005_5898"
        x1="10.5521"
        y1="56.0818"
        x2="40.5389"
        y2="58.2981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCCE6E" />
        <stop offset="1" stop-color="#FAC328" />
      </linearGradient>
    </defs>
  </svg>
</template>
